<template>
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-button :disabled="disabledbool" style="width: 100%" class="is-primary" @click="importModel">
            {{ $translate('catalog_view') }}
          </b-button>
        </div>
        <div class="column is-4 is-offset-1">
          <b-button :disabled="disabledbool" style="width: 100%" class="is-primary" @click="suggDuna">
            {{ $translate('sugg_duna') }}
          </b-button>
        </div>
        <b-tabs position class="blocks fulllength" horizontal>
          <b-tab-item :label="$translate('tomaio') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_tomaio_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <tomaio
                  ref="tomaio"
                  :mod.sync="mod"
                  :orderbool="true"
                  :module="'tailored'"
                  :disabledbool.sync="mod.catalogchoose || mod.color_bool || disabledbool"
                  :availablepell.sync="availablepell"
                  :order-info-mandatory.sync="isTomaioInfoMandatory"
                />
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$translate('fodera') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_fodera_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <fodera
                  ref="fodera"
                  :mod.sync="mod"
                  :orderbool="true"
                  :disabledbool.sync="mod.catalogchoose || mod.color_bool || disabledbool"
                  :availablefode.sync="availablefode"
                  :order-info-mandatory.sync="isFoderaInfoMandatory"
                />
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$translate('allacciatura') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_allacciatura_order') }}
            </h3>
            <p>{{ $translate('alert_allacci') }}</p>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <allacciatura
                  ref="allacciatura"
                  :mod.sync="mod"
                  :orderbool="true"
                  :disabledbool.sync="(mod.custom && !mod.image) || mod.catalogchoose || disabledbool"
                  :availableallacc.sync="availableallacc"
                  :order-info-mandatory.sync="isAllacciaturaInfoMandatory"
                  :is-simplified.sync="isSimplified"
                />
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$translate('suola') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_suola_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <suola
                  ref="suola"
                  :mod.sync="mod"
                  :orderbool="true"
                  :disabledbool.sync="(mod.custom && !mod.image) || mod.catalogchoose || disabledbool"
                  :disabledboolcolor.sync="mod.color_bool"
                  :availablebatt.sync="availablebatt"
                  :availableinter.sync="availableinter"
                  :order-info-mandatory.sync="isSuolaInfoMandatory"
                  :foggia-info-mandatory.sync="isFoggiaInfoMandatory"
                  :is-optional="order.deliverySelected == 'onlytom'"
                  :is-simplified.sync="isSimplified"
                />
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$translate('rifinitura0') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_rifinitura_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" :orderbool="true" />
              </div>
              <template v-if="tempmodelcustom.selectedCatalog == 'from_duna_catalog'">
                <b-field
                  :type="{ 'is-danger': errors.has('catalog_spec') }"
                  :message="errors.first('catalog_spec')"
                  :label="$translate('catalog_spec') | capitalize"
                  horizontal
                >
                  <b-input v-model="tempmodelcustom.catalog_spec" name="catalog_spec" type="text" />
                </b-field>
                <b-field
                  :type="{ 'is-danger': errors.has('catalog_pag') }"
                  :message="errors.first('catalog_pag')"
                  :label="$translate('catalog_pag') | capitalize"
                  horizontal
                >
                  <b-input v-model="tempmodelcustom.catalog_pag" name="catalog_pag" type="number" />
                </b-field>
                <b-field
                  :type="{ 'is-danger': errors.has('model_spec') }"
                  :message="errors.first('model_spec')"
                  :label="$translate('model_spec') | capitalize"
                  horizontal
                >
                  <b-input v-model="tempmodelcustom.model_spec" name="model_spec" type="text" />
                </b-field>
              </template>
              <template v-if="tempmodelcustom.selectedCatalog == 'from_duna_site'">
                <b-field
                  :type="{ 'is-danger': errors.has('model_from_duna_site') }"
                  :message="errors.first('model_from_duna_site')"
                  :label="$translate('model_from_duna_site') | capitalize"
                  horizontal
                >
                  <b-autocomplete
                    v-model="tempmodelcustom.model_from_duna_site"
                    :data="filteredDataObj"
                    field="name"
                    :keep-first="true"
                    :open-on-focus="true"
                    @input="checkModelFromDunaSite"
                  />
                </b-field>
                <b-field
                  :type="{ 'is-danger': errors.has('color_from_duna_site') }"
                  :message="errors.first('color_from_duna_site')"
                  :label="$translate('color_from_duna_site') | capitalize"
                  horizontal
                >
                  <b-input
                    v-model="tempmodelcustom.color_from_duna_site"
                    :disabled="true"
                    name="color_from_duna_site"
                  />
                </b-field>
              </template>

              <template v-if="tempmodelcustom.selectedCatalog == 'from_samples'">
                <b-field horizontal :label="$translate('code_from_samples') | capitalize">
                  <img src="@/assets/images/Barcode.png" style="width: 60%" />
                </b-field>
                <b-field horizontal style="font-weight: bold">
                  12
                  <b-input
                    v-model="tempmodelcustom.code_from_samples"
                    style="margin-top: -5px"
                    name="code_from_samples"
                    maxlength="7"
                    minlength="7"
                  />
                </b-field>
              </template>

              <div class="column is-8">
                <!--<rifinitura
                  ref="rifinitura"
                  :orderbool="true"
                  :mod.sync="mod"
                  :availableguard.sync="availableguard"
                  :availablegomm.sync="availablegomm"
                  :order-info-mandatory.sync="isRifinituraInfoMandatory"
                  :disabledbool.sync="
                    mod.catalogchoose ||
                      disabledbool ||
                      mod.color_bool ||
                      order.deliverySelected == 'onlytom' ||
                      (mod.custom && !mod.image)
                  "
                />-->
                <rifinitura
                  ref="rifinitura"
                  :mod.sync="mod"
                  :orderbool="true"
                  :disabledbool.sync="(mod.custom && !mod.image) || mod.catalogchoose || disabledbool"
                  :availableguard.sync="availableguard"
                  :availablegomm.sync="availablegomm"
                  :order-info-mandatory.sync="isRifinituraInfoMandatory"
                  :is-optional="order.deliverySelected == 'onlytom'"
                  :is-simplified.sync="isSimplified"
                />
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
        <b-modal :active.sync="isComponentModalCustomActive" has-modal-card trap-focus aria-role="dialog" aria-modal>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                {{ $translate('custom_model') | capitalize }}
              </p>
            </header>
            <section class="modal-card-body">
              <!--<b-field v-if="uploadFileBool" :label="$translate('file') | capitalize" horizontal>-->
              <b-field v-if="uploadFile" :label="$translate('file') | capitalize" horizontal>
                <img :src="uploadFile" style="max-width: 100px; max-height: 100px" />
                <b-button @click="removeuploadFile()">
                  {{ $translate('remove_file') }}
                </b-button>
              </b-field>

              <b-field
                v-else
                class="file"
                :label="$translate('file') | capitalize"
                :message="errors.first('file')"
                :type="{ 'is-danger': errors.has('file') }"
                horizontal
              >
                <!--<img
                  v-if="mod.custom && !mod.from_duna_catalog"
                  style="max-width: 100px; max-height: 100px"
                  :src="mod.image ? mod.image : 'https://via.placeholder.com/600'"
                />-->
                <!--<b-button @click="removeFile()">
                  {{ $translate('remove_file') }}
                </b-button>-->
                <b-upload v-model="uploadFile" name="file" accept="image/*" @input="triggerupload()">
                  <a class="button is-primary">
                    <b-icon icon="upload" />
                    <span>{{ $translate('upload_button') }}</span>
                  </a>
                  <span v-if="uploadFile" class="file-name">{{ uploadFile.name }}</span>
                </b-upload>
              </b-field>
              <b-field :label="$translate('attention') | capitalize" horizontal>
                <p>
                  {{ $translate('warning_text_custom_catalog') | capitalize }}
                </p>
              </b-field>
              <b-field :label="$translate('from_duna_catalog') | capitalize" horizontal>
                <b-switch
                  v-model="tempmodelcustom.from_duna_catalog"
                  :disabled="uploadFileBool"
                  @input="updatedSwitch"
                />
              </b-field>
              <template v-if="tempmodelcustom.from_duna_catalog">
                <b-field horizontal>
                  <b-radio
                    v-model="tempmodelcustom.selectedCatalog"
                    name="selectedCatalog"
                    native-value="from_duna_catalog"
                  >
                    {{ $translate('from_duna_catalog') | capitalize }}
                  </b-radio>
                  <b-radio
                    v-model="tempmodelcustom.selectedCatalog"
                    name="selectedCatalog"
                    native-value="from_duna_site"
                    @input="tempmodelcustom.color_bool = true"
                  >
                    {{ $translate('from_duna_site') | capitalize }}
                  </b-radio>
                  <b-radio
                    v-model="tempmodelcustom.selectedCatalog"
                    name="selectedCatalog"
                    native-value="from_samples"
                    @input="tempmodelcustom.color_bool = true"
                  >
                    {{ $translate('from_samples') | capitalize }}
                  </b-radio>
                </b-field>
                <template v-if="tempmodelcustom.selectedCatalog == 'from_duna_catalog'">
                  <b-field
                    :type="{ 'is-danger': errors.has('catalog_spec') }"
                    :message="errors.first('catalog_spec')"
                    :label="$translate('catalog_spec') | capitalize"
                    horizontal
                  >
                    <b-input v-model="tempmodelcustom.catalog_spec" name="catalog_spec" type="text" />
                  </b-field>
                  <b-field
                    :type="{ 'is-danger': errors.has('catalog_pag') }"
                    :message="errors.first('catalog_pag')"
                    :label="$translate('catalog_pag') | capitalize"
                    horizontal
                  >
                    <b-input v-model="tempmodelcustom.catalog_pag" name="catalog_pag" type="number" />
                  </b-field>
                  <b-field
                    :type="{ 'is-danger': errors.has('model_spec') }"
                    :message="errors.first('model_spec')"
                    :label="$translate('model_spec') | capitalize"
                    horizontal
                  >
                    <b-input v-model="tempmodelcustom.model_spec" name="model_spec" type="text" />
                  </b-field>
                </template>

                <template v-if="tempmodelcustom.selectedCatalog == 'from_duna_site'">
                  <b-field
                    :type="{ 'is-danger': errors.has('model_from_duna_site') }"
                    :message="errors.first('model_from_duna_site')"
                    :label="$translate('model_from_duna_site') | capitalize"
                    horizontal
                  >
                    <b-autocomplete
                      v-model="tempmodelcustom.model_from_duna_site"
                      :data="filteredDataObj"
                      field="name"
                      :keep-first="true"
                      :open-on-focus="true"
                      @input="checkModelFromDunaSite"
                    />
                  </b-field>
                  <b-field
                    :type="{ 'is-danger': errors.has('color_from_duna_site') }"
                    :message="errors.first('color_from_duna_site')"
                    :label="$translate('color_from_duna_site') | capitalize"
                    horizontal
                  >
                    <b-input
                      v-model="tempmodelcustom.color_from_duna_site"
                      :disabled="true"
                      name="color_from_duna_site"
                    />
                  </b-field>
                </template>

                <template v-if="tempmodelcustom.selectedCatalog == 'from_samples'">
                  <b-field horizontal :label="$translate('code_from_samples') | capitalize">
                    <img src="@/assets/images/Barcode.png" style="width: 60%" />
                  </b-field>
                  <b-field horizontal style="font-weight: bold">
                    12
                    <b-input
                      v-model="tempmodelcustom.code_from_samples"
                      style="margin-top: -5px"
                      name="code_from_samples"
                      maxlength="7"
                      minlength="7"
                    />
                  </b-field>
                </template>

                <b-field
                  :type="{ 'is-danger': errors.has('color_bool') }"
                  :message="errors.first('color_bool')"
                  :label="$translate('color_bool') | capitalize"
                  horizontal
                >
                  <b-switch
                    v-model="tempmodelcustom.color_bool"
                    :disabled="
                      tempmodelcustom.selectedCatalog == 'from_samples' ||
                        tempmodelcustom.selectedCatalog == 'from_duna_site'
                    "
                  />
                </b-field>
              </template>
              <b-field
                :type="{ 'is-danger': errors.has('details') }"
                :message="errors.first('details')"
                :label="$translate('details') | capitalize"
              >
                <b-input
                  v-model="tempmodelcustom.details"
                  name="details"
                  type="textarea"
                  :disabled="isDetailsDisabled"
                />
              </b-field>
            </section>
            <footer class="modal-card-foot">
              <b-button class="button" type="button" @click="isComponentModalCustomActive = false">
                {{ $translate('close') | capitalize }}
              </b-button>
              <b-button class="button is-primary" type="button" :disabled="checkacceptCustom()" @click="acceptCustom">
                {{ $translate('apply') | capitalize }}
              </b-button>
            </footer>
          </div>
        </b-modal>
        <b-modal :active.sync="isComponentModalActive" has-modal-card trap-focus aria-role="dialog" aria-modal>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                {{ $translate('catalog_view') }} {{ $translate(catalogType) }}
                {{ $translate(shoeType) }}
              </p>
              <b-input v-model="filterModel" />
            </header>
            <section class="modal-card-body">
              <div class="columns is-multiline is-mobile">
                <div v-for="model in filteredModels" :key="model.id" class="column is-one-quarter">
                  <div class="card">
                    <div class="card-image">
                      <figure class="image is-4by3">
                        <img :src="model.image" alt="Placeholder image" />
                      </figure>
                    </div>
                    <div class="card-content" style="height: 96px">
                      <div class="content has-text-centered">
                        {{ model.name }}
                      </div>
                    </div>
                    <footer class="card-footer">
                      <a
                        class="card-footer-item"
                        @click="
                          tempmodel = model
                          //importImage();
                          importBasicData()
                        "
                        >{{ $translate('import') | capitalize }}</a
                      >
                    </footer>
                  </div>
                </div>
                <div :class="{ column: true, 'is-one-quarter': true, opaque: !!isCustomHidden }">
                  <div class="card">
                    <div class="card-image">
                      <figure class="image is-4by3">
                        <img src="https://via.placeholder.com/150x150" alt="Placeholder image" />
                      </figure>
                    </div>
                    <div class="card-content">
                      <div class="content has-text-centered">
                        {{ $translate('custom_model') | capitalize }}
                      </div>
                    </div>
                    <footer class="card-footer">
                      <a v-if="!isCustomHidden" class="card-footer-item" @click="importCustom()">
                        {{ $translate('import') | capitalize }}
                      </a>
                    </footer>
                  </div>
                </div>
              </div>

              <!--
          <b-field :label="$translate('model') | capitalize" horizontal>
            <b-select
              name="model"
              v-model="tempmodel"
              :placeholder="$translate('placeholder_model')"
            >
              <option v-for="model in models" :key="model.id" :value="model">
                {{ model.name }}
              </option>
            </b-select>
              </b-field>-->
            </section>
            <footer class="modal-card-foot">
              <button class="button" type="button" @click="isComponentModalActive = false">
                {{ $translate('close') | capitalize }}
              </button>
              <!--<button
            type="button"
            class="button is-primary"
            @click="
              isComponentModalActive = false;
              $emit('update:mod', tempmodel);
            "
          >
            Importa
              </button>-->
            </footer>
          </div>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
import materialTools from '../../../helpers/mixins/materialTools'
//import modelTools from '../../../helpers/mixins/modelTools'
import { modelTailored, compareModelPosition } from '@/helpers/mixins/modelTools'

import tomaio from '../../Mod/components/tomaio'
import fodera from '../../Mod/components/fodera'
import suola from '../../Mod/components/suola'
import allacciatura from '../../Mod/components/allacciatura'
import rifinitura from '../../Mod/components/rifinitura'
import imageModel from './ImageModel.vue'
import Tomaio from '../../Mod/components/tomaio.vue'
import Rifinitura from '../../Mod/components/rifinitura.vue'
//import allestimento from "../../Mod/components/allestimento";

export default {
  name: 'OrderModel',
  components: {
    //allestimento: allestimento,
    allacciatura: allacciatura,
    suola: suola,
    fodera: fodera,
    tomaio: tomaio,
    rifinitura: rifinitura,
    imageModel: imageModel,
    Tomaio,
    Rifinitura,
  },
  mixins: [materialTools],
  props: {
    mod: {
      type: Object,
      default: () => {
        return {}
      },
    },
    availablepell: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablefode: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablebatt: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableinter: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableguard: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablegomm: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablecont: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablesott: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablepunt: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableallacc: {
      type: Array,
      default: () => {
        return []
      },
    },
    shoeType: {
      type: String,
      default: null,
    },
    catalogType: {
      type: String,
      default: null,
    },
    disabledbool: Boolean,
    catalogModel: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isSaveDisabled: Boolean,
    order: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isSimplified: Boolean,
    isCustomHidden: Boolean,
    config: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
  },
  /*props: [
    "mod",
    "availablepell",
    "availablefode",
    "availablebatt",
    "availableinter",
    "availableguard",
    "availablegomm",
    "availablecont",
    "availablesott",
    "availablepunt",
    "availableallacc",
    "shoeType",
    "catalogType",
    "disabledbool",
    "catalogModel",
    "isSaveDisabled",
    "order",
  ],*/
  inject: ['$validator'],
  data() {
    return {
      models: [],
      isComponentModalActive: false,
      isComponentModalCustomActive: false,
      uploadFile: null,
      uploadFileBool: false,
      tempmodel: {},
      tempmodelcustom: { from_duna_catalog: false, model_from_duna_site: '' },
      web_catalog: [],
      filterModel: '',
    }
  },
  computed: {
    isDetailsDisabled() {
      if (this.tempmodelcustom.from_duna_catalog) {
        if (this.tempmodelcustom.selectedCatalog == 'from_duna_catalog') {
          if (this.tempmodelcustom.color_bool) return true
          return false
        }
        if (this.tempmodelcustom.selectedCatalog == 'from_duna_site') return false
        if (this.tempmodelcustom.selectedCatalog == 'from_samples') return true
      }
      return true
    },
    filteredDataObj() {
      return this.web_catalog.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.tempmodelcustom.model_from_duna_site.toLowerCase()) >= 0
        )
      })
    },
    filteredModels() {
      return this.models
        .filter(model => {
          return model.name.includes(this.filterModel)
        })
        .sort(compareModelPosition)
    },
    isTomaioInfoMandatory() {
      // R7
      return true
    },
    isFoderaInfoMandatory() {
      // R8
      if (this.order.deliverySelected === 'testshoes') return false
      if (this.order.deliverySelected === 'onlyforme') return false
      return true
    },
    isAllacciaturaInfoMandatory() {
      // R9 - R13_3
      return true
    },
    isSuolaInfoMandatory() {
      // R10
      if (this.order.deliverySelected === 'devshoeended') return true
      if (this.order.deliverySelectedSub === 'trymat') return true
      return false
    },
    isFoggiaInfoMandatory() {
      // R11
      if (this.order.deliverySelected === 'devshoeended') return true
      return false
    },
    isRifinituraInfoMandatory() {
      // R12
      if (this.order.deliverySelected === 'devshoeended') return true
      if (this.order.deliverySelectedSub === 'trymat') return true
      return false
    },
    //isTomaioDisabled: () => {
    //  if (this.mod) {
    //  return this.mod.catalogchoose || this.mod.color_bool || this.disabledbool
    //  }
    //  return true
    // }
  },
  watch: {
    shoeType: async function() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }
    },
    catalogType: async function() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }
    },
  },
  created() {},
  mounted() {
    this.$db
      .collection('extras')
      .doc('web_catalog')
      .get()
      .then(doc => {
        this.web_catalog = doc.data().web_catalog
      })
  },
  methods: {
    updatedSwitch() {
      this.$forceUpdate
    },
    checkModelFromDunaSite() {
      if (this.web_catalog.find(el => el.name == this.tempmodelcustom.model_from_duna_site) != undefined) {
        this.tempmodelcustom.color_from_duna_site = this.web_catalog.find(
          el => el.name == this.tempmodelcustom.model_from_duna_site
        ).color
      } else {
        this.tempmodelcustom.color_from_duna_site = null
      }
    },
    removeuploadFile() {
      this.uploadFileBool = false
      this.uploadFile = null
    },
    async triggerupload() {
      this.$emit('update:isSaveDisabled', true)
      let tempid = -1
      if (this.order.id == null) {
        await this.$db
          .collection('orders')
          .add({})
          .then(docRef => {
            tempid = docRef.id
          })
        this.$emit('getid', tempid)
      } else {
        tempid = this.order.id
      }
      if (this.uploadFile && this.uploadFile.name) {
        const storageRef = this.$storage.ref('order/attachment/' + tempid + '/modelcustom')

        await storageRef.put(this.uploadFile).then(async snapshot => {
          await snapshot.ref.getDownloadURL().then(url => {
            this.uploadFileBool = true
            this.tempmodelcustom.from_duna_catalog = false
            this.uploadFile = url
          })
        })
      }
      this.$emit('update:isSaveDisabled', false)
    },
    checkacceptCustom() {
      if (this.tempmodelcustom.from_duna_catalog) {
        switch (this.tempmodelcustom.selectedCatalog) {
          case 'from_duna_catalog':
            if (
              this.tempmodelcustom.catalog_spec != null &&
              this.tempmodelcustom.catalog_spec != '' &&
              this.tempmodelcustom.catalog_pag != null &&
              this.tempmodelcustom.catalog_pag != '' &&
              this.tempmodelcustom.model_spec != null &&
              this.tempmodelcustom.model_spec != ''
            ) {
              return false
            } else {
              return true
            }
          case 'from_duna_site':
            if (
              this.tempmodelcustom.model_from_duna_site != null &&
              this.tempmodelcustom.model_from_duna_site != '' &&
              this.tempmodelcustom.color_from_duna_site != null &&
              this.tempmodelcustom.color_from_duna_site != ''
            ) {
              return false
            } else {
              return true
            }
          case 'from_samples':
            if (this.tempmodelcustom.code_from_samples != null && this.tempmodelcustom.code_from_samples != '') {
              return false
            } else {
              return true
            }
          default:
            return true
        }
      } else {
        if (this.uploadFileBool) {
          return false
        } else {
          return true
        }
      }
    },
    acceptCustom() {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('reset_model_question'),
        cancelText: this.$translate('n'),
        confirmText: this.$translate('y'),
        type: 'is-danger',
        hasIcon: true,
        onCancel: () => {
          this.applyAcceptCustom()
        },
        onConfirm: () => {
          let tempMod = new modelTailored()
          tempMod = tempMod.returnObject()
          tempMod.allacci.push({})
          tempMod.catalogchoose = true
          this.mod = tempMod
          this.$emit('update:mod', this.mod)
          this.applyAcceptCustom()
        },
      })
    },
    applyAcceptCustom() {
      if (this.uploadFile) {
        var tempmod = this.mod
        tempmod.from_duna_catalog = false
        tempmod.image = this.uploadFile
        tempmod.color_bool = false
        this.$emit('update:mod', tempmod)
        //this.removeuploadFile()
      } else {
        if (this.tempmodelcustom.from_duna_catalog) {
          let tempmod = {}
          tempmod.image = null
          tempmod.shoeType = this.mod.shoeType
          tempmod.catalogType = this.mod.catalogType
          tempmod.color_bool = this.tempmodelcustom.color_bool
          tempmod.custom = this.tempmodelcustom.custom
          tempmod.from_duna_catalog = this.tempmodelcustom.from_duna_catalog
          tempmod.catalogchoose = this.tempmodelcustom.catalogchoose
          tempmod.allacci = []
          tempmod.allacci.push({})
          tempmod.selectedCatalog = this.tempmodelcustom.selectedCatalog

          switch (this.tempmodelcustom.selectedCatalog) {
            case 'from_duna_catalog':
              tempmod.catalog_pag = this.tempmodelcustom.catalog_pag
              tempmod.catalog_spec = this.tempmodelcustom.catalog_spec
              tempmod.model_spec = this.tempmodelcustom.model_spec
              break
            case 'from_duna_site':
              tempmod.model_from_duna_site = this.tempmodelcustom.model_from_duna_site
              tempmod.color_from_duna_site = this.tempmodelcustom.color_from_duna_site
              break
            case 'from_samples':
              tempmod.code_from_samples = this.tempmodelcustom.code_from_samples
              break
          }
          //this.tempmodelcustom = { model_from_duna_site: '' }
          tempmod.catalogchoose = false
          tempmod.custom = true

          this.$emit('update:mod', tempmod)
        }
      }

      this.mod.catalogchoose = false
      this.mod.custom = true
      this.mod.name = null
      this.disabledbool = false
      this.isComponentModalCustomActive = false
      this.$forceUpdate()
    },
    refreshCatalog() {
      if (this.catalogModel != undefined) {
        this.$db
          .collection(this.config.models)
          .where('catalogType', '==', this.catalogType)
          .where('shoeType', '==', this.shoeType)
          .where('draft', '==', false)
          .get()
          .then(docs => {
            this.models = []
            docs.forEach(doc => {
              let mode = doc.data()
              mode.id = doc.id
              if (this.catalogModel[mode.id]) {
                this.models.push(mode)
              }
            })
            this.$forceUpdate()
            return
          })
      }
    },
    updateAfterload() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }

      this.$refs.tomaio.updateAfterload()
      this.$refs.fodera.updateAfterload()
      this.$refs.suola.updateAfterload()
      this.$refs.rifinitura.updateAfterload()
    },
    importCustom() {
      this.isComponentModalActive = false
      this.isComponentModalCustomActive = true
    },
    setBasicModelTomaioCount(modelReference, modelToUpdate) {
      const config = this.$moduleConfiguration['tailored']
      let pellCount = 0
      for (const key of Object.keys(modelReference || {})) {
        const match = key.match(/^pell(\d+)mat$/)
        if (match && modelReference[key] != null && Number(match[1]) > pellCount) pellCount = Number(match[1])
      }
      if (pellCount === 0) pellCount = 1
      for (let i = 1; i <= config.maxPel; i++) {
        if (i <= pellCount) {
          this.$set(modelToUpdate, `pell${i}mat`, '')
          this.$set(modelToUpdate, `pell${i}var`, null)
        } else {
          this.$delete(modelToUpdate, `pell${i}mat`)
          this.$delete(modelToUpdate, `pell${i}var`)
        }
      }
    },
    importImage() {
      this.$buefy.notification.open({
        duration: 3000,
        message: this.$translate('warning_import_model'),
        type: 'is-warning',
      })

      var tempmop = this.mod
      tempmop.image = this.tempmodel.image
      this.mod.catalogchoose = false
      this.mod.custom = false
      this.disabledbool = false
      this.setBasicModelTomaioCount(this.tempmodel, tempmop)
      this.$emit('update:mod', tempmop)
      this.isComponentModalActive = false
      this.$refs.tomaio.updateAfterload()
    },
    importBasicData() {
      this.$buefy.notification.open({
        duration: 3000,
        message: this.$translate('warning_import_model'),
        type: 'is-warning',
      })
      let tempMod = this.mod
      tempMod.image = this.tempmodel.image
      tempMod.name = this.tempmodel.name
      tempMod.id = this.tempmodel.id
      tempMod.color_bool = false
      this.mod.catalogchoose = false
      this.mod.custom = false
      this.disabledbool = false
      this.setBasicModelTomaioCount(this.tempmodel, tempMod)
      this.$emit('update:mod', tempMod)
      this.isComponentModalActive = false
      this.$refs.tomaio.updateAfterload()
    },
    suggDuna() {
      if (this.mod.custom) {
        this.$buefy.dialog.alert({
          title: this.$translate('attention'),
          message: this.$translate('custom_model_alert_no_duna'),
        })
      } else {
        if (this.mod.image) {
          this.$buefy.dialog.confirm({
            title: this.$translate('attention'),
            message: this.$translate('alert_model'),
            cancelText: this.$translate('undo'),
            confirmText: this.$translate('confirm'),
            onConfirm: async () => {
              const cloneDeep = require('clone-deep')
              await this.$emit('update:mod', cloneDeep(this.tempmodel))
              let temp = cloneDeep(this.mod)
              for (let element in temp) {
                if (temp[element] == undefined) {
                  //console.log(element);
                  temp[element] = null
                }
              }
              for (const key of [
                'addingchar',
                'addingcharfod',
                'components_to_drill',
                'var_ling_sx',
                'var_ling_dx',
                'allacci',
              ]) {
                if (!temp[key]) temp[key] = []
              }
              this.$emit('update:mod', cloneDeep(temp))
            },
          })
        } else {
          this.$buefy.toast.open(this.$translate('error_sugg'))
        }
      }
    },
    importModel() {
      if (this.shoeType != null && this.catalogType != null) {
        this.isComponentModalActive = true
      } else {
        //this.$buefy.toast.open(`Specifica il catalogo e il tipo di calzatura`);
        this.$buefy.toast.open(this.$translate('error_catalog'))
      }
    },
    deliveryUpdated() {
      this.$forceUpdate()
    },
  },
}
</script>
<style>
.opaque {
  opacity: 0.5;
}
</style>
